import e from "./_coreJsData.js";
var a = function() {
  var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function t(r) {
  return !!a && a in r;
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_isMasked.js
// module id = 1483
// module chunks = 41